module.exports = __webpack_public_path__ + "static/img/MV17.02feb39.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fotografias/MV17.jpg
// module id = /xdN
// module chunks = 0